import jwtDecode from "jwt-decode";

const getUserFromToken = () => {
	const token = localStorage.getItem("access-token");

	if (token) {
		const id = jwtDecode(token).EmployeeId;
		// const id = jwtDecode(token).UserId;
		return id;
	}
};

export default getUserFromToken;
